// extracted by mini-css-extract-plugin
export default {"companyContainer":"FT-z","companyImage":"GT-z","container":"HT-z","heading":"IT-z","darkText":"JT-z","smallHeading":"KT-z","darkBackground":"LT-z","whiteBackground":"MT-z"};